import {
  VStack,
  Skeleton,
  SkeletonCircle,
  Flex,
  SimpleGrid,
  HStack,
  useBreakpointValue,
} from '@wegroup/design-system';
import React from 'react';

const QuestionViewSkeleton: React.FC<React.PropsWithChildren<unknown>> = () => {
  const isMobile = useBreakpointValue({ base: true, laptop: false });
  const isTablet = useBreakpointValue({
    base: false,
    tablet: true,
    laptop: false,
  });

  if (isMobile) {
    return (
      <Flex flexDirection="column" align="stretch" w="100%" h="100%">
        <Flex
          px="6"
          pt="4"
          pb="10"
          align={{ base: 'stretch', tablet: 'center' }}
          flexDirection="column"
          flexGrow={1}
          background="white"
        >
          {isTablet ? (
            <QuestionViewSkeletonDesktopContent />
          ) : (
            <QuestionViewSkeletonMobileContent />
          )}
        </Flex>
        <HStack
          height="76px"
          p="4"
          background="white"
          border="1px"
          borderColor="gray.50"
          spacing="4"
        >
          <SkeletonCircle size="44px" />
          <Skeleton height="40px" borderRadius="full" flexGrow={1} />
        </HStack>
      </Flex>
    );
  }

  return (
    <VStack
      align="stretch"
      justifyContent="space-between"
      flexDirection="column"
      px="10"
      pb="14"
      pt="24"
      h="100%"
      flexGrow={1}
    >
      <Flex align="center" flexDir="column">
        <SkeletonCircle size="24" mb="8" />
        <QuestionViewSkeletonDesktopContent />
      </Flex>
      <HStack spacing="10" justify="center">
        <Skeleton height="30px" width="200px" />
        <Skeleton height="30px" width="200px" />
      </HStack>
    </VStack>
  );
};

const QuestionViewSkeletonDesktopContent: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <>
      <Skeleton height="14px" maxW="64rem" mb="6" w="100%" />
      <Skeleton height="14px" maxW="40rem" w="75%" mb="14" />
      <SimpleGrid columns={2} spacing="10" maxW="90rem" w="100%">
        <Skeleton height="40px" />
        <Skeleton height="40px" />
        <Skeleton height="40px" />
        <Skeleton height="40px" />
      </SimpleGrid>
    </>
  );
};

const QuestionViewSkeletonMobileContent: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <>
      <VStack align="stretch" spacing="2" mb="4">
        <Skeleton height="24px" />
        <Skeleton height="24px" w="75%" />
      </VStack>

      <VStack align="stretch" spacing="2" mb="6">
        <Skeleton height="14px" />
        <Skeleton height="14px" w="75%" />
      </VStack>

      <VStack align="stretch" spacing="4">
        <Skeleton height="40px" maxW="45rem" />
        <Skeleton height="40px" maxW="45rem" />
      </VStack>
    </>
  );
};

export default QuestionViewSkeleton;
